import { Text } from '@doda/io-react/common';
import type { JobSearchResultResponse } from '@doda/api-client/aspida/@types';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import { textAjust, removeLF } from '@doda/common/src/utils/convTextUtil';

/**
 * 求人カード アピールDE
 * @param message 一覧専用ﾒｯｾｰｼﾞ
 */
interface AppealDEProps {
  message: JobSearchResultResponse['listExclusiveMessage'];
}

export const AppealDE = ({ message = '' }: AppealDEProps) => {
  const adjustedMessage = textAjust(message ?? '', 130);

  return (
    <Text color="gray" size="12">
      <TextWithLF text={adjustedMessage} />
    </Text>
  );
};

/**
 * 求人カード アピールBC
 * @param title 企業概要ヘッダー
 * @param subTitle 企業概要サブヘッダー
 * @param body 企業概要本文
 */
interface AppealBCProps {
  title: JobSearchResultResponse['companyOverviewHeading'];
  subTitle: JobSearchResultResponse['companyOverviewSubHeading'];
  body: JobSearchResultResponse['companyOverviewText'];
}

export const AppealBC = ({
  title = '',
  subTitle = '',
  body = '',
}: AppealBCProps) => {
  const adjustedTitle = title?.slice(0, 30);
  const adjustedSubTitle = subTitle?.slice(0, 30);
  const adjustedBody = textAjust(removeLF(body), 135);

  return (
    <AppealABC
      title={adjustedTitle}
      subTitle={adjustedSubTitle}
      body={adjustedBody}
    />
  );
};

/**
 * 求人カード アピールA
 * @param title 一覧専用見出し
 * @param subTitle 一覧専用サブ見出し
 * @param body 一覧専用ﾒｯｾｰｼﾞ
 */
interface AppealAProps {
  title: JobSearchResultResponse['listExclusiveHeading'];
  subTitle: JobSearchResultResponse['listExclusiveSubHeading'];
  body: JobSearchResultResponse['listExclusiveMessage'];
}

export const AppealA = ({
  title = '',
  subTitle = '',
  body = '',
}: AppealAProps) => {
  const adjustedTitle = title?.slice(0, 30);
  const adjustedSubTitle = subTitle?.slice(0, 30);
  const adjustedBody = textAjust(removeLF(body), 155);

  return (
    <AppealABC
      title={adjustedTitle}
      subTitle={adjustedSubTitle}
      body={adjustedBody}
    />
  );
};

/**
 * 求人カード アピールABC共通パーツ
 * @param title 一覧専用見出し
 * @param subTitle 一覧専用サブ見出し
 * @param body 一覧専用ﾒｯｾｰｼﾞ
 */
interface AppealABCProps {
  title: string | undefined;
  subTitle: string | undefined;
  body: string;
}

const AppealABC = ({
  title = '',
  subTitle = '',
  body = '',
}: AppealABCProps) => {
  return (
    <div>
      <Text color="gray" size="12" weight="bold">
        {title}
      </Text>
      {subTitle && (
        <Text color="gray" size="12" weight="bold">
          {subTitle}
        </Text>
      )}
      <Text color="gray" size="12" style={{ marginBlockStart: 12 }}>
        {body}
      </Text>
    </div>
  );
};
